import { ExperienceSource } from 'model/IExperience';
import { translateDuration } from 'utils/TranslationHelper';

export function experienceDuration(experience: ExperienceSource) {
  const days = parseInt(experience?.attributes?.duration_days ?? '10', 10);
  const hours = parseInt(experience?.attributes?.duration ?? '10', 10);
  const minutes = parseInt(experience?.attributes?.duration_minutes ?? '0', 10);
  return translateDuration(hours + minutes / 60, days);
}
